import { Component, OnInit } from '@angular/core';
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

interface attrList {
  attr_name: string;
  attr_url: string;
}

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit {

  isOpen = true;

  toggle() {
    this.isOpen = !this.isOpen;
  }

  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleDoubleRight = faAngleDoubleRight;

  list:attrList[]  = [
    {attr_name: '그리드 기본 샘플', attr_url: '/pages/basic'},
    {attr_name: '그리드 토탈 샘플', attr_url: '/pages/total'},
    {attr_name: '그리드 드래그 앤 드롭 샘플', attr_url: '/pages/drag-and-drop'},
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
